<template>
    <div class="modal-card">
        <header class="modal-card-head pop-header">
            <p class="modal-card-title tit">
                안전 교육
            </p>
        </header>
        <section class="modal-card-body pop-content">
            <div class="inner-box">
                <div id="safePop" style="height: 600px; overflow-y:scroll; margin-bottom: 10px">
                    <img src="../../img/safe_st_01.png" />
                </div>

                <input type="checkbox" id="agreeChk" v-model="agreeChk"><label for="agreeChk">상기내용을 확인하였으며, 이에 동의합니다.</label><br>
                <button class="button-close" @click="closeModal" style="margin-top: 10px">
                    닫기
                </button>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "safePop",
    data() {
        return {
            title: "안전교육",
            agreeChk: false,
            isScrollDown: false,
            scrollTop: 0,
            target: null,
            scrollPosition: 0
        }
    },
    methods: {
        closeModal() {
            /* 일부 핸드폰에서 동작이 안됨. 주석처리
            if(this.isScrollDown != true){
                this.$swal({
                    type: 'warning',
                    text: '안전수칙을 아래까지 다 읽어주시기 바랍니다.'
                });
                return
            }*/

            if(this.agreeChk == false){
                this.$swal({
                    type: 'warning',
                    text: '안전수칙에 동의해주시기 바랍니다.'
                });
                return
            }

            this.$parent.close();
        },
        handleScroll() {
            this.scrollTop = this.target.scrollHeight - this.target.scrollTop - this.target.clientHeight

            if(this.scrollTop < 50) {
                this.isScrollDown = true
            } else {
                this.isScrollDown = false
            }
        }
    },

    mounted() {
        this.target = document.querySelector('#safePop')
        this.target.addEventListener('scroll', this.handleScroll)
    },
}
</script>

<style>
.inner-box{
    height: 100%;
    width:100%;
    left: 0;
    right: 0;
    margin: 0 auto 30px;
}

.inner-box button{
    padding:10px;
    border:1px solid #d5d5d5;
    text-align:center;
    font-weight: bold;
}

.inner-box .button-request{
    background-color: #023e7c;
    color:#fff;
    width:100px;
}

.inner-box .button-close{
    background-color: #b3b3b3;
    color:#fff;
    width:100px;
    margin-left:10px;
}

.modal-content{
    max-width: 650px;
}
.modal-card {
    width: 100%;
}

@media (max-width: 1000px) {
    .modal-card  {
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
    }/*
    .modal-card  {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
        display: flex;
    }*/
}
</style>